<template>
  <el-dialog
    :title="dialogInfo.setType == 1 ? '增加总名额' : '扣除剩余库存'"
    :visible.sync="dialogInfo.show"
    v-if="dialogInfo.show"
    width="500px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    distroy-on-close
  >
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      size="small"
      :rules="rules"
      label-position="left"
      label-width="210px"
    >
      <div v-if="dialogInfo.setType == 1">
        <div class="item" v-if="ruleForm.offline.bizType == 2">
          <div class="item_title">
            线下学习：共<span class="base-hover-char">{{
              ruleForm.offline.totalCount
            }}</span
            >名额，剩<span class="base-hover-char">{{
              ruleForm.offline.count
            }}</span
            >名额
          </div>
          <el-row>
            <el-col :span="19">
              <el-form-item prop="offNum" label="线下学习总名额 = 现有总名额 +">
                <el-input
                  placeholder="请输入整数"
                  v-model="ruleForm.offNum"
                  type="number"
                  :min="1"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3" class="m-l-24">
              <butn
                btntype="primary"
                @click.native="sureSubmit(2)"
                title="保存"
              ></butn>
            </el-col>
          </el-row>
        </div>
        <div class="item" v-if="ruleForm.online.bizType == 1">
          <div class="item_title">
            线上学习：共<span class="base-hover-char">{{
              ruleForm.online.totalCount
            }}</span
            >名额，剩<span class="base-hover-char">{{
              ruleForm.online.count
            }}</span
            >名额
          </div>
          <el-row>
            <el-col :span="19">
              <el-form-item prop="onNum" label="线上学习总名额 = 现有总名额 +">
                <el-input
                  placeholder="请输入整数"
                  v-model="ruleForm.onNum"
                  type="number"
                  :min="1"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3" class="m-l-24">
              <butn
                btntype="primary"
                @click.native="sureSubmit(1)"
                title="保存"
              ></butn>
            </el-col>
          </el-row>
        </div>
      </div>
      <div v-else>
        <div class="item" v-if="ruleForm.offline.bizType == 2">
          <div class="item_title">
            线下学习：共<span>{{ ruleForm.offline.totalCount }}</span
            >名额，剩<span class="base-hover-char">{{
              ruleForm.offline.count
            }}</span
            >名额
          </div>
          <el-row>
            <el-col :span="19">
              <el-form-item prop="offNum" label="线下学习剩余库存 = 实际库存 -">
                <el-input
                  placeholder="请输入整数"
                  v-model="ruleForm.offNum"
                  type="number"
                  :min="1"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3" class="m-l-24">
              <butn
                btntype="primary"
                @click.native="sureSubmit(2)"
                title="保存"
              ></butn>
            </el-col>
          </el-row>
        </div>
        <div class="item" v-if="ruleForm.online.bizType == 1">
          <div class="item_title">
            线上学习：共<span>{{ ruleForm.online.totalCount }}</span
            >名额，剩<span class="base-hover-char">{{
              ruleForm.online.count
            }}</span
            >名额
          </div>
          <el-row>
            <el-col :span="19">
              <el-form-item prop="onNum" label="线上学习剩余库存 = 实际库存 -">
                <el-input
                  placeholder="请输入整数"
                  v-model="ruleForm.onNum"
                  type="number"
                  :min="1"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3" class="m-l-24">
              <butn
                btntype="primary"
                @click.native="sureSubmit(1)"
                title="保存"
              ></butn>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>
  
<script>
import { getTicketCount, setTicketCount } from "@/api/liveRoom.js";
import butn from "@/components/button/index";

export default {
  components: { butn },
  props: {
    dialogInfo: {
      type: Object,
      default: function () {
        return {
          setType: 1, // 调整类型（1增加 2减少）
          id: "",
        };
      },
    },
  },
  data() {
    return {
      ruleForm: {
        online: {},
        offline: {},
        onNum: null,
        offNum: null,
      },
      rules: {
        onNum: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || (!!value && value.length === 0)) {
                callback(new Error("请输入正整数"));
              } else if (value < 1) {
                callback(new Error("请输入正整数"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        offNum: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || (!!value && value.length === 0)) {
                callback(new Error("请输入正整数"));
              } else if (value < 1) {
                callback(new Error("请输入正整数"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    if (this.dialogInfo.id) {
      this.getInfo();
    }
  },
  methods: {
    closeDia() {
      this.$emit("closeDialog", false);
    },
    getInfo() {
      getTicketCount({ ticketId: this.dialogInfo.id }).then((res) => {
        if (res.code !== 0) return;
        let resp = res.data;
        for (let i = 0; i < resp.length; i++) {
          if (resp[i].bizType == 1) {
            this.ruleForm.online = resp[i];
          } else this.ruleForm.offline = resp[i];
        }
      });
    },
    sureSubmit(bizType) {
      let reg = /(^[0-9]*[1-9][0-9]*)$/;
      if (bizType == 1) {
        if (!reg.test(this.ruleForm.onNum )) {
          return this.$message.error("请输入正整数！");
        }
        if (this.ruleForm.onNum > 1000000) {
          return this.$message.error("限制最大数值为1000000！");
        }
      } else {
        if (!reg.test(this.ruleForm.offNum )) {
          return this.$message.error("请输入正整数！");
        }
        if (this.ruleForm.offNum > 1000000) {
          return this.$message.error("限制最大数值为1000000！");
        }
      }
      let text = "";
      if (this.dialogInfo.setType == 1) {
        text = "确认增加总名额吗？";
      } else {
        text = "确认扣除库存吗？";
      }
      this.$confirm(text, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            bizType, // 业务类型（1线上 2线下)
            setType: this.dialogInfo.setType,
          };
          if (bizType == 1) {
            params.ticketDetailId = this.ruleForm.online.ticketDetailId;
            params.num = this.ruleForm.onNum;
          } else {
            params.ticketDetailId = this.ruleForm.offline.ticketDetailId;
            params.num = this.ruleForm.offNum;
          }
          setTicketCount(params).then((res) => {
            if (res && res.code == 0) {
              this.$message.success(res.msg);
              // 更新数据
              this.getInfo();
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
  
<style lang="scss" scoped>
.item {
  margin-bottom: 48px;
  .item_title {
    font-size: 1.2rem;
    margin-bottom: 16px;
  }
  /deep/ .el-form-item__label,
  .el-input--small {
    font-size: 14px !important;
    color: #51627d;
    padding: 0 !important;
  }
  /deep/ .el-button--small {
    font-size: 14px !important;
    padding: 8px 15px;
  }
}
.m-l-24 {
  margin-left: 16px;
}
/deep/ .el-dialog__body {
  padding: 38px 38px 0 38px;
}
</style>
  